import { Directive, Renderer2, ElementRef, HostListener, OnDestroy, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { Product } from '@vestiaire/api-sdk-angular';
import { IsLoggedGuard } from '@app/shared/guards';
import { Subscription } from 'rxjs';

import * as fromCart from '@app/core/cart/reducers';
import * as cartActions from '@app/core/cart/actions/cart.actions';

@Directive({
  selector: '[appAddToCart]'
})
export class AddToCartDirective implements OnDestroy {
  private classes: string[] = [];
  private product: Product;
  private subscription: Subscription;

  public isActive = false;

  constructor(
    private store: Store<IAppState>,
    private element: ElementRef,
    private renderer: Renderer2,
    private loggedGuard: IsLoggedGuard
  ) {
    this.subscription = this.store.pipe(select(fromCart.getCartPending)).subscribe(
      res => this.update(res),
      err => this.update(false)
    );
  }

  @Input()
  withPopin: boolean;

  @Input()
  set appAddToCart(product: Product) {
    this.product = product;
  }

  @Input()
  set addToCartActive(data: string[] | string) {
    const classes = Array.isArray(data) ? data : data.split(' ');
    this.classes = classes.filter(c => !!c);
  }

  @HostListener('click')
  onClick(): void {
    if (this.loggedGuard.isLoggedIn()) {
      this.setActive();
      this.addToCart();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setActive(active: boolean = true) {
    this.isActive = active;
    this.toggleClasses(active);
  }

  update(pending: boolean) {
    if (this.isActive) {
      this.isActive = pending;
      this.toggleClasses(pending);
    }
  }

  toggleClasses(active: boolean) {
    this.classes.forEach(name => {
      if (active) {
        this.renderer.addClass(this.element.nativeElement, name);
      } else {
        this.renderer.removeClass(this.element.nativeElement, name);
      }

      this.renderer.setAttribute(this.element.nativeElement, 'disabled', '' + active);
    });
  }

  addToCart(): void {
    this.store.dispatch(
      new cartActions.AddToCart({
        product: this.product,
        openDialog: this.withPopin
      })
    );
  }
}
